// extracted by mini-css-extract-plugin
module.exports = {"section":"Section-module--section--35E8i","sectionInner":"Section-module--sectionInner--3B0PK","rotation":"Section-module--rotation--wZFuU","pulse":"Section-module--pulse--Holk7"};